import type { ColumnSpecification } from 'state/selectedProject/selectedProjectHooks';

export function getColumnSpecificationStatistics(
  columnSpecificationByIndexMap: {
    [number: string]: ColumnSpecification;
  },
  gridLoadingContext: GridLoadingContext
) {
  const result = Object.keys(columnSpecificationByIndexMap).reduce(
    (prev, curr) => {
      const column = columnSpecificationByIndexMap[curr];

      const isSemanticEditColumn = column.isSemanticEdit && !column.isDisabled && column.columnIndex !== 0;

      return {
        semanticEditColumns: prev.semanticEditColumns + (isSemanticEditColumn ? 1 : 0),
        totalNumberOfColumns: prev.totalNumberOfColumns + 1,
        syntacticEditColumns: prev.semanticEditColumns + (column.isSemanticEdit ? 0 : 1),
        disabledColumns: prev.semanticEditColumns + (column.isDisabled ? 1 : 0),
        totalWidth: prev.totalWidth + column.width
      };
    },
    {
      semanticEditColumns: 0,
      totalNumberOfColumns: 0,
      syntacticEditColumns: 0,
      disabledColumns: 0,
      totalWidth: 0
    }
  );

  if (gridLoadingContext.type === 'viewport') {
    const { width, height } = gridLoadingContext;
    const requiresHorizontalScrolling = result.totalWidth > width;
    // e.g. 66% will mean 66% percent of the horizontal space was not utilized,
    // a negative number like -50% will mean that the horizontal viewport 50% too small
    const horizontalFreeSpacePercentage = (width - result.totalWidth) * (100 / width);

    return {
      ...result,
      viewPortHeight: height,
      viewPortWidth: width,
      requiresHorizontalScrolling,
      horizontalFreeSpacePercentage
    };
  } else {
    return { ...result };
  }
}

export type GridLoadingContext = { type: 'viewport'; height: number; width: number } | { type: 'refresh' };
